module.exports = __webpack_public_path__ + "img/Rectangle 20.f7e061e8.png";